export const firstSection = [
  { name: "Familia Rotulada", translation: 'Labeled Family' },
  { name: "Origem", translation: 'Source' },
  { name: "Status", translation: 'Status' },
  { name: "Estoque Liberado", translation: 'Available Stock'},
  { name: "Estoque Bloqueado", translation: 'Stock Blocked'},
  { name: "Estoque Total", translation: 'Total Stock' },
  { name: "Valor Total", translation: 'Amount' }
]
